import * as yup from 'yup'

// login validation
export const subCostSchema = yup.object().shape({
    monthly_sub_cost: yup
        .number()
        .typeError('سعر التكلفة يجب ان يكون رقم')
        .required('من فضلك ادخل  سعر الاشتراك فى الشهر!'),
})
